import React, { useState } from "react";
import styles from './dwn-style.module.css';
import {useLocation } from "react-router-dom";


const FitDemographics = () => {
  const [demographicData, setDemographicData] = useState({
    parentGender: "",                      // Parent's gender
    parentGenderIdentity: "",             // Parent's gender identity
    otherGenderIdentity: "",              // Description for custom gender identity
    parentDOB: "",                        // Parent's date of birth
    highestGradeFinished: "",             // Highest grade completed by the parent
    worksOutside: "",                     // Whether the parent works outside
    occupation: "",                       // Parent's occupation
    computerAccess: "",                   // Access to a computer
    internetOnComputer: "",               // Internet access on a computer
    cellPhoneAccess: "",                  // Access to a cell phone
    internetOnPhone: "",                  // Internet access on a phone
    nutritionProgram: "",                 // Participation in a nutrition program
    programEnrolled: "",                  // Specific nutrition program enrolled
    relationshipToChild: "",              // Relationship to the child
    otherRelationshipDescription: "",     // Description for "other" relationship
    relationshipStatus: "",               // Parent's relationship status
    incomeCategory: "",                   // Parent's income category
    workHours: "",                        // Weekly work hours
    employmentMonths: "",                 // Months employed in the last year
    childGender: "",                      // Child's gender
    childGenderIdentity: "",              // Child's gender identity
    otherChildGenderIdentity: "",              // Description for child's custom gender identity
    childDOB: "",                         // Child's date of birth
    teenGrade: "",                        // Teen's grade level
    specialEducation: "",                 // Teen's participation in special education
    teenDiagnosis: "",                    // Teen's diagnosis (if any)
    diagnosisDetails: "",                 // Details about the diagnosis
    teenSports: "",                       // Teen's participation in sports
    teenSportDetails: "",                 // Details about the sports
    
  
    hispanicLatinoOrigin: {               // Parent's Hispanic/Latino origin
      no: false,
      mexican: false,
      puertoRican: false,
      cuban: false,
      anotherHispanic: false,
      otherHispanicDescription: "",      // Description for "another Hispanic origin"
    },
  
    race: {                               // Parent's race
      white: false,
      blackOrAfricanAmerican: false,
      americanIndianOrAlaskaNative: false,
      asianIndian: false,
      chinese: false,
      filipino: false,
      japanese: false,
      korean: false,
      vietnamese: false,
      otherAsian: false,
      nativeHawaiian: false,
      guamanianOrChamorro: false,
      samoan: false,
      otherPacificIslander: false,
    },
  
    teenHispanicLatinoOrigin: {           // Teen's Hispanic/Latino origin
      no: false,
      mexican: false,
      puertoRican: false,
      cuban: false,
      anotherHispanic: false,
      otherHispanicDescription: "",      // Description for "another Hispanic origin"
    },
  
    teenRace: {                           // Teen's race
      white: false,
      blackOrAfricanAmerican: false,
      americanIndianOrAlaskaNative: false,
      asianIndian: false,
      chinese: false,
      filipino: false,
      japanese: false,
      korean: false,
      vietnamese: false,
      otherAsian: false,
      nativeHawaiian: false,
      guamanianOrChamorro: false,
      samoan: false,
      otherPacificIslander: false,
    },

    moneyIssues: {
      foodOrTransport: false,
      housing: false,
      highHousingCosts: false,
      largeDebt: false,
      lateOnBill: false,
      vicesSpending: false,
      borrowedMoney: false,
      foodBank: false,
      moneyArguments: false,
    },
    financialAid: {
      foodStamps: false,
      socialSecurity: false,
      supplementalIncome: false,
      temporaryAssistance: false,
      aidForDisabledChildren: false,
      otherAid: false,
    },
    otherAidDetails: "",
  });
  
  
 const location = useLocation()
  const [onBoardData] = useState(location.state.onBoardData)
  const [eligibility] = useState(location.state.eligibility)


  const handleChange = (e) => {
    const { name, value } = e.target;
    setDemographicData((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const handleCheckboxChange = (event, category) => {
    const { name, checked } = event.target;
    setDemographicData((prevState) => ({
      ...prevState,
      [category]: {
        ...prevState[category],
        [name]: checked,
      },
    }));
  };

  const handleTextChange = (event, category) => {
    const { name, value } = event.target;
    setDemographicData((prevState) => ({
      ...prevState,
      [category]: {
        ...prevState[category],
        [name]: value,
      },
    }));
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    console.log("Form submitted with data:", demographicData);
    submitSignupData()
  };

  const submitSignupData = async () => {

    let connectionString = "https://app.digitalwellnessnurse.com" //https://app.digitalwellnessnurse.com  http://localhost:2001

    try {
      const response = await fetch(connectionString+'/api/portal/fit/onboard', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({onBoardData: onBoardData, demographicData: demographicData, eligibility:eligibility}),
      });

      if (response.ok) {
        const data = await response.json();
        alert('Signup successful!');
        console.log(data);
      } else {
        alert('Signup failed. Please try again.');
        console.error('Error:', response.statusText);
      }
    } catch (error) {
      alert('An error occurred. Please try again.');
      console.error('Error:', error);
    }
  };


  return (
   <div className={styles.signupForm}>
    <form onSubmit={handleSubmit}>
      <h2>Parent Information</h2>
      <div className={styles.form2Group}>
        <label>What was your sex at birth:
          <select name="parentGender" value={demographicData.parentGender} onChange={handleChange} required>
            <option value="">Select</option>
            <option value="Male">Male</option>
            <option value="Female">Female</option>
            <option value="Prefer not say/unknown">Prefer not say/unknown</option>
          </select>
        </label>
      </div>
      <div className={styles.form2Group}>
      <label>
        What is your gender identity:
        <select
          name="parentGenderIdentity"
          value={demographicData.parentGenderIdentity}
          onChange={handleChange}
          required
        >
          <option value="">Select</option>
          <option value="Man/boy">Man/boy</option>
          <option value="Woman/girl">Woman/girl</option>
          <option value="Non-Binary">Non-Binary</option>
          <option value="Transgender man/trans man/female-to-male (FTM)">
            Transgender man/trans man/female-to-male (FTM)
          </option>
          <option value="Transgender woman/trans woman/male-to-female (MTF)">
            Transgender woman/trans woman/male-to-female (MTF)
          </option>
          <option value="Genderqueer/gender nonconforming neither exclusively male nor female">
            Genderqueer/gender nonconforming neither exclusively male nor female
          </option>
          <option value="Additional gender category (or other)">
            Additional gender category (or other); please specify:
          </option>
          <option value="Decline to answer">Decline to answer</option>
        </select>
      </label>

      {demographicData.parentGenderIdentity === 'Additional gender category (or other)' && (
        <div>
          <label>
            If "Other", please describe your gender identity:
            <input
              type="text"
              name="otherGenderIdentity"
              value={demographicData.otherGenderIdentity}
              onChange={handleChange}
              placeholder="Please specify"
              required
            />
          </label>
        </div>
      )}
      </div>
      <div className={styles.form2Group}>
        <label>Are you Hispanic, Latino/a, or Spanish origin?</label>
        <div className={styles.checkboxGroup}>
          <label className={styles.checkboxItem}>
            <input
              type="checkbox"
              name="no"
              checked={demographicData.hispanicLatinoOrigin.no}
              onChange={(e) => handleCheckboxChange(e, 'hispanicLatinoOrigin')}
            />
            No, not of Hispanic, Latino/a, or Spanish origin
          </label>
          <label className={styles.checkboxItem}>
            <input
              type="checkbox"
              name="mexican"
              checked={demographicData.hispanicLatinoOrigin.mexican}
              onChange={(e) => handleCheckboxChange(e, 'hispanicLatinoOrigin')}
            />
            Mexican, Mexican American, Chicano/a
          </label>
          <label className={styles.checkboxItem}>
            <input
              type="checkbox"
              name="puertoRican"
              checked={demographicData.hispanicLatinoOrigin.puertoRican}
              onChange={(e) => handleCheckboxChange(e, 'hispanicLatinoOrigin')}
            />
            Puerto Rican
          </label>
          <label className={styles.checkboxItem}>
            <input
              type="checkbox"
              name="cuban"
              checked={demographicData.hispanicLatinoOrigin.cuban}
              onChange={(e) => handleCheckboxChange(e, 'hispanicLatinoOrigin')}
            />
            Cuban
          </label>
          <label className={styles.checkboxItem}>
            <input
              type="checkbox"
              name="anotherHispanic"
              checked={demographicData.hispanicLatinoOrigin.anotherHispanic}
              onChange={(e) => handleCheckboxChange(e, 'hispanicLatinoOrigin')}
            />
            Another Hispanic, Latino, or Spanish origin
          </label>
        </div>
        {demographicData.hispanicLatinoOrigin.anotherHispanic && (
          <div className={styles.form2Group}>
            <label className="specifyLabel">Please specify:</label>
            <input
              type="text"
              name="otherHispanicDescription"
              value={demographicData.hispanicLatinoOrigin.otherHispanicDescription}
              onChange={(e) => handleTextChange(e, 'hispanicLatinoOrigin')}
              placeholder="Specify origin"
              className="textInput"
            />
          </div>
        )}
      </div>

      <div className={styles.form2Group}>
        <label>What is your race?</label>
        <div className={styles.checkboxGroup}>
          {[
            { name: 'white', label: 'White' },
            { name: 'blackOrAfricanAmerican', label: 'Black or African American' },
            { name: 'americanIndianOrAlaskaNative', label: 'American Indian or Alaska Native' },
            { name: 'asianIndian', label: 'Asian Indian' },
            { name: 'chinese', label: 'Chinese' },
            { name: 'filipino', label: 'Filipino' },
            { name: 'japanese', label: 'Japanese' },
            { name: 'korean', label: 'Korean' },
            { name: 'vietnamese', label: 'Vietnamese' },
            { name: 'otherAsian', label: 'Other Asian' },
            { name: 'nativeHawaiian', label: 'Native Hawaiian' },
            { name: 'guamanianOrChamorro', label: 'Guamanian or Chamorro' },
            { name: 'samoan', label: 'Samoan' },
            { name: 'otherPacificIslander', label: 'Other Pacific Islander' },
          ].map((raceOption) => (
            <label key={raceOption.name} className={styles.checkboxItem}>
              <input
                type="checkbox"
                name={raceOption.name}
                checked={demographicData.race[raceOption.name]}
                onChange={(e) => handleCheckboxChange(e, 'race')}
              />
              {raceOption.label}
            </label>
          ))}
        </div>
      </div>
      <div className={styles.form2Group}>
        <label>Date of Birth:
          <input type="date" name="parentDOB" value={demographicData.parentDOB} onChange={handleChange} required />
        </label>
      </div>
      {/* Highest Grade Finished */}
      <div className={styles.form2Group}>
        <label>What is the highest grade in school you finished?</label>
        <select
          name="highestGradeFinished"
          value={demographicData.highestGradeFinished}
          onChange={handleChange}
          required
        >
          <option value="">Select</option>
          <option value="Did not finish elementary school">Did not finish elementary school</option>
          <option value="Finished middle school (8th grade)">Finished middle school (8th grade)</option>
          <option value="Finished some high school">Finished some high school</option>
          <option value="High School Graduate or G.E.D.">High School Graduate or G.E.D.</option>
          <option value="Vocational or training school after high school">
            Vocational or training school after high school
          </option>
          <option value="Some college or Associate Degree">Some college or Associate Degree</option>
          <option value="College graduate or Baccalaureate Degree">
            College graduate or Baccalaureate Degree
          </option>
          <option value="Masters (MS) or Doctoral Degree (PhD, MD, JD, etc.)">
            Masters (MS) or Doctoral Degree (PhD, MD, JD, etc.)
          </option>
        </select>
      </div>


      {/* Occupation */}
      <div className={styles.form2Group}>
        <label>What is your occupation and job title?</label>
        <input
          type="text"
          name="occupation"
          value={demographicData.occupation}
          onChange={handleChange}
          placeholder="Enter your occupation and job title"
          required
        />
      </div>

      {/* Computer Access */}
      <div className={styles.form2Group}>
        <label>Do you have daily access to a computer at home?</label>
        <div className={styles.form2Group}>
          <input
            type="radio"
            name="computerAccess"
            value="Yes"
            checked={demographicData.computerAccess === "Yes"}
            onChange={handleChange}
          />
          Yes
        </div>
        <div className={styles.form2Group}>
          <input
            type="radio"
            name="computerAccess"
            value="No"
            checked={demographicData.computerAccess === "No"}
            onChange={handleChange}
          />
          No
        </div>
      </div>

      {/* Internet on Computer */}
      <div className={styles.form2Group}>
        <label>Do you have daily access to the internet on this home computer?</label>
        <div className={styles.form2Group}>
          <input
            type="radio"
            name="internetOnComputer"
            value="Yes"
            checked={demographicData.internetOnComputer === "Yes"}
            onChange={handleChange}
          />
          Yes
        </div>
        <div className={styles.form2Group}>
          <input
            type="radio"
            name="internetOnComputer"
            value="No"
            checked={demographicData.internetOnComputer === "No"}
            onChange={handleChange}
          />
          No
        </div>
      </div>

      {/* Cell Phone Access */}
      <div className={styles.form2Group}>
        <label>Do you have daily access to a cell phone?</label>
        <div className={styles.form2Group}>
          <input
            type="radio"
            name="cellPhoneAccess"
            value="Yes"
            checked={demographicData.cellPhoneAccess === "Yes"}
            onChange={handleChange}
          />
          Yes
        </div>
        <div className={styles.form2Group}>
          <input
            type="radio"
            name="cellPhoneAccess"
            value="No"
            checked={demographicData.cellPhoneAccess === "No"}
            onChange={handleChange}
          />
          No
        </div>
      </div>

      {/* Internet on Cell Phone */}
      <div className={styles.form2Group}>
        <label>Do you have daily access to the internet on this cell phone?</label>
        <div className={styles.form2Group}>
          <input
            type="radio"
            name="internetOnPhone"
            value="Yes"
            checked={demographicData.internetOnPhone === "Yes"}
            onChange={handleChange}
          />
          Yes
        </div>
        <div className={styles.form2Group}>
          <input
            type="radio"
            name="internetOnPhone"
            value="No"
            checked={demographicData.internetOnPhone === "No"}
            onChange={handleChange}
          />
          No
        </div>
      </div>

      {/* Nutrition Program */}
      <div className={styles.form2Group}>
        <label>Are you a part of a supplemental nutrition program (like SNAP)?</label>
        <div className={styles.form2Group}>
          <input
            type="radio"
            name="nutritionProgram"
            value="Yes"
            checked={demographicData.nutritionProgram === "Yes"}
            onChange={handleChange}
          />
          Yes
        </div>
        <div className={styles.form2Group}>
          <input
            type="radio"
            name="nutritionProgram"
            value="No"
            checked={demographicData.nutritionProgram === "No"}
            onChange={handleChange}
          />
          No
        </div>
      </div>
      {/* Program Enrolled */}
      <div className={styles.form2Group}>
        <label>What program are you currently enrolled in?</label>
        <input
          type="text"
          name="programEnrolled"
          value={demographicData.programEnrolled}
          onChange={handleChange}
          placeholder="Enter program name"
        />
      </div>
    {/* Relationship to Child */}
    <div className={styles.form2Group}>
  <label>What is your relationship to this child?</label>
  <select
    name="relationshipToChild"
    value={demographicData.relationshipToChild}
    onChange={handleChange}
    required
  >
    <option value="">Select</option>
    <option value="Biological Parent">Biological Parent</option>
    <option value="Step-Parent">Step-Parent</option>
    <option value="Adoptive Parent (non-family)">Adoptive Parent (non-family)</option>
    <option value="Guardian (non-family)">Guardian (non-family)</option>
    <option value="Foster Parent">Foster Parent</option>
    <option value="Adoptive parent (family)">Adoptive parent (family)</option>
    <option value="Guardian (family)">Guardian (family)</option>
    <option value="Other">Other</option>
  </select>
</div>

{demographicData.relationshipToChild === "Other" && (
  <div className={styles.form2Group}>
    <label>You selected "Other" in response to the previous question. Please describe:</label>
    <input
      type="text"
      name="otherRelationshipDescription"
      value={demographicData.otherRelationshipDescription}
      onChange={handleChange}
      placeholder="Describe your relationship"
      className={styles.textInput}
    />
  </div>
)}
      {/* Relationship Status */}
      <div className={styles.form2Group}>
        <label>What is your current relationship status?</label>
        <select
          name="relationshipStatus"
          value={demographicData.relationshipStatus}
          onChange={handleChange}
          required
        >
          <option value="">Select</option>
          <option value="Single or casually dating">Single or casually dating</option>
          <option value="Living in a marriage-like relationship">Living in a marriage-like relationship</option>
          <option value="Separated">Separated</option>
          <option value="Widowed">Widowed</option>
          <option value="In a committed relationship or engaged">
            In a committed relationship or engaged
          </option>
          <option value="Presently married">Presently married</option>
          <option value="Divorced">Divorced</option>
        </select>
      </div>

      {/* Income */}
      <div className={styles.form2Group}>
        <label>Which of these categories best describes your income?</label>
        <select
          name="incomeCategory"
          value={demographicData.incomeCategory}
          onChange={handleChange}
          required
        >
          <option value="">Select</option>
          <option value="Less than $5,000">Less than $5,000</option>
          <option value="$5,000 through $11,999">$5,000 through $11,999</option>
          <option value="$12,000 through $15,999">$12,000 through $15,999</option>
          <option value="$16,000 through $24,999">$16,000 through $24,999</option>
          <option value="$25,000 through $34,999">$25,000 through $34,999</option>
          <option value="$35,000 through $49,999">$35,000 through $49,999</option>
          <option value="$50,000 through $74,999">$50,000 through $74,999</option>
          <option value="$75,000 through $99,999">$75,000 through $99,999</option>
          <option value="$100,000 or greater">$100,000 or greater</option>
          <option value="Don't know">Don't know</option>
        </select>
      </div>


      {/* Work Hours */}
      <div className={styles.form2Group}>
        <label>How many hours do you work per week on average?</label>
        <input
          type="number"
          name="workHours"
          value={demographicData.workHours}
          onChange={handleChange}
          placeholder="Enter hours per week"
          required
        />
      </div>

      {/* Employment Months */}
      <div className={styles.form2Group}>
        <label>How many months were you employed in the last year?</label>
        <input
          type="number"
          name="employmentMonths"
          value={demographicData.employmentMonths}
          onChange={handleChange}
          placeholder="Enter months"
          required
        />
      </div>

      <div className={styles.form2Group}>
  <label>Do you work outside the home?</label>
  <input
    type="radio"
    name="worksOutside"
    value="Yes"
    checked={demographicData.worksOutside === "Yes"}
    onChange={handleChange}
  /> Yes
  <input
    type="radio"
    name="worksOutside"
    value="No"
    checked={demographicData.worksOutside === "No"}
    onChange={handleChange}
  /> No
</div>
      {/* Occupation */}
      <div className={styles.form2Group}>
        <label>What is your occupation and job title?</label>
        <input
          type="text"
          name="occupation"
          value={demographicData.occupation}
          onChange={handleChange}
          placeholder="Enter your occupation and job title"
          required
        />
      </div>




      {/* Money Issues Section */}
      <div className={styles.checkboxGroup}>
        <label className={styles.checkboxGroupLabel}>In the past year, have you:</label>
        {[
          { name: "foodOrTransport", label: "Run out of money for food or transportation" },
          { name: "housing", label: "Run out of money for housing" },
          {
            name: "highHousingCosts",
            label: "Spent half or more of your income on housing and utilities (electricity, gas, cable, water)",
          },
          {
            name: "largeDebt",
            label: "Not counting a home or car loan, owed people more than what you make in two months",
          },
          { name: "lateOnBill", label: "Been 120 days or more behind on a bill" },
          { name: "vicesSpending", label: "Spent money that was needed for bills on alcohol, drugs, or gambling" },
          {
            name: "borrowedMoney",
            label: "Had to borrow money from another family member or close friend for food, rent, or utilities",
          },
          { name: "foodBank", label: "Had to use food bank, soup kitchen or emergency shelter" },
          { name: "moneyArguments", label: "Argued regularly with other people in your family or household about money" },
        ].map((item) => (
          <div className={styles.checkboxItem} key={item.name}>
            <input
              type="checkbox"
              id={item.name}
              name={item.name}
              onChange={(e) => handleCheckboxChange(e, "moneyIssues")}
              checked={demographicData.moneyIssues[item.name]}
            />
            <label htmlFor={item.name}>{item.label}</label>
          </div>
        ))}
      </div>

      {/* Financial Aid Section */}
      <div className={styles.checkboxGroup}>
        <label className={styles.checkboxGroupLabel}>
          Do you or other adults living in the home receive any of the following kinds of financial aid?
        </label>
        {[
          { name: "foodStamps", label: "Food stamps/WIC" },
          { name: "socialSecurity", label: "Social Security Disability (SSD)" },
          { name: "supplementalIncome", label: "Supplemental Security Income (SSI)" },
          { name: "temporaryAssistance", label: "Temporary Assistance for Needy Families (TANF)" },
          { name: "aidForDisabledChildren", label: "Aid to Families with Disabled Children" },
          { name: "otherAid", label: "Other" },
        ].map((item) => (
          <div className={styles.checkboxItem} key={item.name}>
            <input
              type="checkbox"
              id={item.name}
              name={item.name}
              onChange={(e) => handleCheckboxChange(e, "financialAid")}
              checked={demographicData.financialAid[item.name]}
            />
            <label htmlFor={item.name}>{item.label}</label>
          </div>
        ))}
      </div>
      {demographicData.financialAid.otherAid && (
        <div className={styles.formGroup}>
          <label htmlFor="otherAidDetails" className={styles.label}>
            Specify "Other" kind of financial aid:
          </label>
          <input
            type="text"
            id="otherAidDetails"
            name="otherAidDetails"
            value={demographicData.otherAidDetails}
            onChange={handleChange}
            placeholder="Enter details"
            className={styles.textInput}
          />
        </div>
      )}










      <h2>Teen Information</h2>

      <div className={styles.form2Group}>
        <label>What was the teen sex at birth:
          <select name="childGender" value={demographicData.childGender} onChange={handleChange} required>
            <option value="">Select</option>
            <option value="Male">Male</option>
            <option value="Female">Female</option>
            <option value="Prefer not say/unknown">Prefer not say/unknown</option>
          </select>
        </label>
      </div>
      <div className={styles.form2Group}>
        <label>What is the teen gender identity :
          <select name="childGenderIdentity" value={demographicData.childGenderIdentity} onChange={handleChange} required>
            <option value="">Select</option>
            <option value="Man/boy">Man/boy</option>
            <option value="Woman/girl">Woman/girl</option>
            <option value="Non-Binary">Non-Binary</option>
            <option value="Transgender man/trans man/female-to-male (FTM)">
                  Transgender man/trans man/female-to-male (FTM)
            </option>
            <option value="Transgender woman/trans woman/male-to-female (MTF)">
                Transgender woman/trans woman/male-to-female (MTF)
            </option>
            <option value="Genderqueer/gender nonconforming neither exclusively male nor female">
              Genderqueer/gender nonconforming neither exclusively male nor female
            </option>
            <option value="Additional gender category (or other)">Additional gender category (or other); please specify:</option>
            <option value="Decline to answer">Decline to answer</option>
              </select>
        </label>
        {demographicData.childGenderIdentity === 'Additional gender category (or other)' && (
        <div>
          <label>
            If "Other", please describe your gender identity:
            <input
              type="text"
              name="otherChildGenderIdentity"
              value={demographicData.otherGenderIdentity}
              onChange={handleChange}
              placeholder="Please specify"
              required
            />
          </label>
        </div>
      )}
      </div>
      <div className={styles.form2Group}>
      <label>Is the teen Hispanic, Latino/a, or Spanish origin?</label>
      <div className={styles.checkboxGroup}>
        <label className={styles.checkboxItem}>
          <input
            type="checkbox"
            name="teenNo"
            checked={demographicData.teenHispanicLatinoOrigin?.no || false}
            onChange={(e) =>
              setDemographicData((prev) => ({
                ...prev,
                teenHispanicLatinoOrigin: {
                  ...prev.teenHispanicLatinoOrigin,
                  no: e.target.checked,
                },
              }))
            }
          />
          No, not of Hispanic, Latino/a, or Spanish origin
        </label>
        <label className={styles.checkboxItem}>
          <input
            type="checkbox"
            name="teenMexican"
            checked={demographicData.teenHispanicLatinoOrigin?.mexican || false}
            onChange={(e) =>
              setDemographicData((prev) => ({
                ...prev,
                teenHispanicLatinoOrigin: {
                  ...prev.teenHispanicLatinoOrigin,
                  mexican: e.target.checked,
                },
              }))
            }
          />
          Mexican, Mexican American, Chicano/a
        </label>
        <label className={styles.checkboxItem}>
          <input
            type="checkbox"
            name="teenPuertoRican"
            checked={demographicData.teenHispanicLatinoOrigin?.puertoRican || false}
            onChange={(e) =>
              setDemographicData((prev) => ({
                ...prev,
                teenHispanicLatinoOrigin: {
                  ...prev.teenHispanicLatinoOrigin,
                  puertoRican: e.target.checked,
                },
              }))
            }
          />
          Puerto Rican
        </label>
        <label className={styles.checkboxItem}>
          <input
            type="checkbox"
            name="teenCuban"
            checked={demographicData.teenHispanicLatinoOrigin?.cuban || false}
            onChange={(e) =>
              setDemographicData((prev) => ({
                ...prev,
                teenHispanicLatinoOrigin: {
                  ...prev.teenHispanicLatinoOrigin,
                  cuban: e.target.checked,
                },
              }))
            }
          />
          Cuban
        </label>
        <label className={styles.checkboxItem}>
          <input
            type="checkbox"
            name="teenAnotherHispanic"
            checked={demographicData.teenHispanicLatinoOrigin?.anotherHispanic || false}
            onChange={(e) =>
              setDemographicData((prev) => ({
                ...prev,
                teenHispanicLatinoOrigin: {
                  ...prev.teenHispanicLatinoOrigin,
                  anotherHispanic: e.target.checked,
                },
              }))
            }
          />
          Another Hispanic, Latino, or Spanish origin
        </label>
      </div>
      {demographicData.teenHispanicLatinoOrigin?.anotherHispanic && (
        <div className={styles.form2Group}>
          <label className="specifyLabel">Please specify:</label>
          <input
            type="text"
            name="teenOtherHispanicDescription"
            value={demographicData.teenHispanicLatinoOrigin?.otherHispanicDescription || ''}
            onChange={(e) =>
              setDemographicData((prev) => ({
                ...prev,
                teenHispanicLatinoOrigin: {
                  ...prev.teenHispanicLatinoOrigin,
                  otherHispanicDescription: e.target.value,
                },
              }))
            }
            placeholder="Specify origin"
            className="textInput"
          />
        </div>
      )}
    </div>

    <div className={styles.form2Group}>
      <label>What is the teen's race?</label>
      <div className={styles.checkboxGroup}>
        {[
          { name: 'white', label: 'White' },
          { name: 'blackOrAfricanAmerican', label: 'Black or African American' },
          { name: 'americanIndianOrAlaskaNative', label: 'American Indian or Alaska Native' },
          { name: 'asianIndian', label: 'Asian Indian' },
          { name: 'chinese', label: 'Chinese' },
          { name: 'filipino', label: 'Filipino' },
          { name: 'japanese', label: 'Japanese' },
          { name: 'korean', label: 'Korean' },
          { name: 'vietnamese', label: 'Vietnamese' },
          { name: 'otherAsian', label: 'Other Asian' },
          { name: 'nativeHawaiian', label: 'Native Hawaiian' },
          { name: 'guamanianOrChamorro', label: 'Guamanian or Chamorro' },
          { name: 'samoan', label: 'Samoan' },
          { name: 'otherPacificIslander', label: 'Other Pacific Islander' },
        ].map((raceOption) => (
          <label key={`teen${raceOption.name}`} className={styles.checkboxItem}>
            <input
              type="checkbox"
              name={raceOption.name}
              checked={demographicData.teenRace?.[raceOption.name] || false}
              onChange={(e) =>
                setDemographicData((prev) => ({
                  ...prev,
                  teenRace: {
                    ...prev.teenRace,
                    [raceOption.name]: e.target.checked,
                  },
                }))
              }
            />
            {raceOption.label}
          </label>
        ))}
      </div>
    </div>

      <div className={styles.form2Group}>
        <label>What is the teen date of birth:
          <input type="date" name="childDOB" value={demographicData.childDOB} onChange={handleChange} required />
        </label>
      </div>

      {/* Teen Grade */}
      <div className={styles.form2Group}>
        <label>What grade is your teen currently in?</label>
        <select
          name="teenGrade"
          value={demographicData.teenGrade}
          onChange={handleChange}
          required
        >
          <option value="">Select</option>
          <option value="3rd grade">3rd grade</option>
          <option value="4th grade">4th grade</option>
          <option value="5th grade">5th grade</option>
          <option value="6th grade">6th grade</option>
          <option value="7th grade">7th grade</option>
          <option value="8th grade">8th grade</option>
          <option value="9th grade">9th grade</option>
          <option value="10th grade">10th grade</option>
          <option value="11th grade">11th grade</option>
          <option value="12th grade">12th grade</option>
        </select>
      </div>

      {/* Teen Special Education */}
      <div className={styles.form2Group}>
        <label>Does your teen currently receive special education classes at school?</label>
        <div className={styles.form2Group}>
          <input
            type="radio"
            name="specialEducation"
            value="Yes"
            checked={demographicData.specialEducation === "Yes"}
            onChange={handleChange}
          />
          Yes
        </div>
        <div className={styles.form2Group}>
          <input
            type="radio"
            name="specialEducation"
            value="No"
            checked={demographicData.specialEducation === "No"}
            onChange={handleChange}
          />
          No
        </div>
      </div>

      {/* Teen Diagnosis */}
      <div className={styles.form2Group}>
        <label>
          Have you ever been told that your teen has an additional diagnosis, such as autism or an intellectual
          disability?
        </label>
        <div className={styles.form2Group}>
          <input
            type="radio"
            name="teenDiagnosis"
            value="Yes"
            checked={demographicData.teenDiagnosis === "Yes"}
            onChange={handleChange}
          />
          Yes
        </div>
        <div className={styles.form2Group}>
          <input
            type="radio"
            name="teenDiagnosis"
            value="No"
            checked={demographicData.teenDiagnosis === "No"}
            onChange={handleChange}
          />
          No
        </div>
        {demographicData.teenDiagnosis === "Yes" && (
          <div className={styles.form2Group}>
            <label>Describe the problem:</label>
            <textarea
              name="diagnosisDetails"
              value={demographicData.diagnosisDetails}
              onChange={handleChange}
              placeholder="Enter details"
            />
          </div>
        )}
      </div>

      {/* Teen Sports */}
      <div className={styles.form2Group}>
        <label>Does your teen participate in sports or other physical activity?</label>
        <div className={styles.form2Group}>
          <input
            type="radio"
            name="teenSports"
            value="Yes"
            checked={demographicData.teenSports === "Yes"}
            onChange={handleChange}
          />
          Yes
        </div>
        <div className={styles.form2Group}>
          <input
            type="radio"
            name="teenSports"
            value="No"
            checked={demographicData.teenSports === "No"}
            onChange={handleChange}
          />
          No
        </div>    
      </div>

      <button className={styles.generateBtn} type="button" onClick={handleSubmit}>Submit</button>
      
    </form>
    </div>
  );
};

export default FitDemographics;

